export const FlexContainer: React.FC = ({ children }) => (
  <div className="is-flex is-align-items-center">
    {children}
  </div>
)